import { render, staticRenderFns } from "./EditTableCol.vue?vue&type=template&id=85c89cc8"
import script from "./EditTableCol.vue?vue&type=script&lang=js"
export * from "./EditTableCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports